import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileRepositoryComponent } from './file-repository.component';
import { FileRepositorySummaryComponent } from './file-repository-summary/file-repository-summary.component';
import { FileRepositoryDialogComponent } from './file-repository-dialog/file-repository-dialog.component';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {LayoutModule} from '../../components/layout/layout.module';
import {MaterialModule} from '../../material.module';
import { FileRepositoryStatusPipe } from './file-repository-status.pipe';
import {FlexModule} from '@angular/flex-layout';
import {DialogModule} from '../../components/dialog/dialog.module';
import {ArmFormTitleModule} from '../../components/arm-form/arm-form-title/arm-form-title.module';
import {FormsModule} from '@angular/forms';
import {InfraModule} from 'ac-infra';
import {SearchModule} from '../../components/search/search.module';



@NgModule({
  declarations: [FileRepositoryComponent, FileRepositorySummaryComponent, FileRepositoryDialogComponent, FileRepositoryStatusPipe],
    imports: [
        CommonModule,
        ArmTableModule,
        ActionBarModule,
        LayoutModule,
        MaterialModule,
        FlexModule,
        DialogModule,
        ArmFormTitleModule,
        FormsModule,
        InfraModule,
        SearchModule
    ]
})
export class FileRepositoryModule { }
